import { fetchAPI } from '.'

import { AuditLogStreamingPortalLinkResponse, AuditLogStreamingStatusResponse } from '@/api/generated/api'

export async function getAuditLogStreamingStatus() {
  return fetchAPI<AuditLogStreamingStatusResponse>({
    method: 'GET',
    url: '/audit-log-streaming/status',
  })
}

// WorkOS setup is always an external redirect — no inline/iframe path.
export async function setupAuditLogStreaming() {
  return fetchAPI<AuditLogStreamingPortalLinkResponse>({
    method: 'POST',
    url: '/audit-log-streaming/setup',
  })
}

export async function updateAuditLogStreamingRetention(retentionPeriodInDays: 30 | 365) {
  return fetchAPI<AuditLogStreamingStatusResponse>({
    method: 'PATCH',
    url: '/audit-log-streaming/retention',
    data: { retention_period_in_days: retentionPeriodInDays },
  })
}
